import { initUrlParamsReducer } from "./url/redux";

export const rootReducer = {
    urlParams: initUrlParamsReducer,
};
